"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryId = void 0;
const createUid_1 = require("./createUid");
const createQueryId = () => {
    return (0, createUid_1.createUid)();
};
exports.createQueryId = createQueryId;
